import React from "react";
import {CardBody, CardText} from "reactstrap";

const DeliveryLogsCard = ({data}) => {
  const {delivery_id, timestamp, message} = data;

  return (
    <CardBody>
      <CardText>{`Delivery ID: ${delivery_id}`}</CardText>
      <CardText>{`Timestamp: ${timestamp}`}</CardText>
      <CardText>
        {"Status: "} <RenderStatus data={data} />{" "}
      </CardText>
      <CardText>{`Message: ${message}`}</CardText>
    </CardBody>
  );
};

export default DeliveryLogsCard;

const STATUS_COLOUR_CLASS = {
  success: "text-success",
  failed: "text-danger",
  retrying: "text-warning",
  pending: "text-muted",
};

// An unlisted status gets a distinct colour so it stands out instead of looking
// like a normal muted "pending" row.
const UNKNOWN_STATUS_CLASS = "text-info";

const UNKNOWN_STATUS_LABEL = "Unknown";

export const RenderStatus = ({data}) => {
  const {status} = data;
  const trimmed = String(status ?? "").trim();
  const key = trimmed.toLowerCase();

  // Never render an empty badge: fall back to the raw value, then to "Unknown".
  const label = trimmed || UNKNOWN_STATUS_LABEL;

  return (
    <span
      className={`text-capitalize ${STATUS_COLOUR_CLASS[key] ?? UNKNOWN_STATUS_CLASS}`}
    >
      {label}
    </span>
  );
};
